import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import Albums from '../../data/Albums.json';

export class News extends Component {
  showAlbum = () => {
    document.getElementById("m-news").classList.add('d-none');
    document.getElementById("m-vids").classList.add('d-none');
    document.getElementById("m-gal").classList.remove('d-none');
  }
  showVid = () => {
    document.getElementById("m-news").classList.add('d-none');
    document.getElementById("m-vids").classList.remove('d-none');
    document.getElementById("m-gal").classList.add('d-none');
  }
  render() {
    return (
      <div id="m-news" className="row">
        <div className="col-sm-12 col-md-12 col-xl-9">
          <div className="card blog-card">
            <div className="row">
              <div className="col-sm-12">
                <span className="tag">NEWS</span>
              </div>
            </div>
            <div className="row newss">
              <div className="no-rp col-2 col-sm-1 col-md-2 col-xl-1">
                <span className="day light-blue-text">10</span>
                <span className="mmyy light-blue-text">MAY<br />2019</span>
              </div>
              <div className="col-10 col-sm-11 col-md-10 col-xl-11">
                <p className="article-title">
                  FSDH Limited gets Merchant Bank license
                    </p>
                <p>
                  First Securities Doscount House Limited, the precursor to FSDH Merchant Bank
                  Limited, was incorporated in June 1992 as the first discount house to operate in Nigeria. In the new era, FSDH Merchant Bank Limited was one of the firstmerchant banks to b granted a license toggleoperate in Nigeria as a merchant bank.
                    </p>
                <p>
                  Over the years, the FSDH Group has become a financial srvices supermarket
                  that delivers expert financial services in the Nigerian market to its select clientele, thereby assisting them to create long sustainable wealth.
                    </p>
              </div>
            </div>
            <div className="row">
              <div className="no-rp col-2 col-sm-1 col-md-2 col-xl-1">
                <span className="day light-blue-text">03</span>
                <span className="mmyy light-blue-text">MAY<br />2019</span>
              </div>
              <div className="col-10 col-sm-11 col-md-10 col-xl-11">
                <p className="article-title">
                  FSDH Limited gets Merchant Bank license
                    </p>
                <p>
                  First Securities Doscount House Limited, the precursor to FSDH Merchant Bank
                  Limited, was incorporated in June 1992 as the first discount house to operate in Nigeria. In the new era, FSDH Merchant Bank Limited was one of the firstmerchant banks to b granted a license toggleoperate in Nigeria as a merchant bank.
                    </p>
                <p>
                  Over the years, the FSDH Group has become a financial srvices supermarket
                  that delivers expert financial services in the Nigerian market to its select clientele, thereby assisting them to create long sustainable wealth.
                    </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-xl-3 white-text cadar-links">
          <div className='row'>
            <div className='col-6 col-xl-12'>
              <div className="card media-card dark-blue-bg">
                <span>GALLERY</span>
                <div className="to-bottom">
                  <p className="media-big-text bold">Gallery</p>
                  <button onClick={this.showAlbum} className="white-bordered-button-sm">View all</button>
                </div>
              </div>
            </div>
            <div className='col-6 col-xl-12'>
              <div className="card media-card burgundy-bg">
                <span>VIDEOS</span>
                <div className="to-bottom">
                  <p className="media-big-text bold">Videos</p>
                  <button onClick={this.showVid} className="white-bordered-button-sm">Learn more</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export class Gallery extends Component {
  showNews = () => {
    document.getElementById("m-gal").classList.add('d-none');
    document.getElementById("m-vids").classList.add('d-none');
    document.getElementById("m-news").classList.remove('d-none');
  }
  showVid = () => {
    document.getElementById("m-news").classList.add('d-none');
    document.getElementById("m-vids").classList.remove('d-none');
    document.getElementById("m-gal").classList.add('d-none');
  }
  render() {
    return (
      <div className="row d-none" id="m-gal">
        <div className="col-sm-12 col-md-12 col-xl-9">
          <div className="card blog-card">
            <div className="row">
              <div className="col-sm-12">
                <span className="tag text-uppercase">Gallery</span>
              </div>
            </div>
            <br />
            <Table hover size="sm">
              {/* <thead>
                <tr className="d-flex">
                  <th className='text-uppercase bold col-4'></th>
                  <th className="text-uppercase bold col-2"></th>
                  <th className="text-uppercase bold col-4"></th>
                  <th className='text-uppercase bold col-2'></th>
                </tr>
              </thead> */}
              <tbody>
                {
                  Albums.Albums.map(album => {
                    return (
                      <tr key={album.id} className="d-flex">
                        <td className="col-4">{album.title}</td>
                        <td className="col-2"></td>
                        <td className="col-4">{album.date}</td>
                        <td className="col-2"><Link className='btn btn-link light-blue-text' to={album.link}>View More</Link></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-xl-3 white-text cadar-links">
          <div className='row'>
            <div className='col-6 col-xl-12'>
              <div className="card media-card dark-blue-bg">
                <span>NEWS</span>
                <div className="to-bottom">
                  <p className="media-big-text bold">News</p>
                  <button onClick={this.showNews} className="white-bordered-button-sm">View News</button>
                </div>
              </div>
            </div>
            <div className='col-6 col-xl-12'>
              <div className="card media-card burgundy-bg">
                <span>VIDEOS</span>
                <div className="to-bottom">
                  <p className="media-big-text bold">Videos</p>
                  <button onClick={this.showVid} className="white-bordered-button-sm">Learn more</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export class Videos extends Component {
  showNews = () => {
    document.getElementById("m-gal").classList.add('d-none');
    document.getElementById("m-vids").classList.add('d-none');
    document.getElementById("m-news").classList.remove('d-none');
  }
  showAlbum = () => {
    document.getElementById("m-news").classList.add('d-none');
    document.getElementById("m-gal").classList.remove('d-none');
    document.getElementById("m-vids").classList.add('d-none');
  }
  render() {
    return (
      <div className="row d-none" id='m-vids'>
        <div className="col-sm-12 col-md-12 col-xl-9">
          <div className="card blog-card">
            <div className="row">
              <div className="col-sm-12">
                <span className="tag text-uppercase">Videos</span>
              </div>
            </div>
            <br />
            <Table hover size="sm">
              {/* <thead>
                <tr className="d-flex">
                  <th className='text-uppercase bold col-4'></th>
                  <th className="text-uppercase bold col-2"></th>
                  <th className="text-uppercase bold col-4"></th>
                  <th className='text-uppercase bold col-2'></th>
                </tr>
              </thead> */}
              <tbody>
                {
                  Albums.Videos.map(video => {
                    return (
                      <tr key={video.id} className="d-flex">
                        <td className="col-4">{video.title}</td>
                        <td className="col-2"></td>
                        <td className="col-4">{video.date}</td>
                        <td className="col-2"><Link className='btn btn-link light-blue-text' to={video.link}>View More</Link></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-xl-3 white-text cadar-links">
          <div className='row'>
            <div className='col-6 col-xl-12'>
              <div className="card media-card dark-blue-bg">
                <span>GALLERY</span>
                <div className="to-bottom">
                  <p className="media-big-text bold">Gallery</p>
                  <button onClick={this.showAlbum} className="white-bordered-button-sm">View All</button>
                </div>
              </div>
            </div>
            <div className='col-6 col-xl-12'>
              <div className="card media-card burgundy-bg">
                <span>NEWS</span>
                <div className="to-bottom">
                  <p className="media-big-text bold">News</p>
                  <button onClick={this.showNews} className="white-bordered-button-sm">View News</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
